import React from 'react';
import styled from 'styled-components';

import {colors} from 'styles/shared';

const Title = styled.div`
  font-size: 6rem;
  line-height: 7.2rem;
  color: ${colors.darkBlue_darker};
  margin-bottom: 6rem;
`;

function AuthTitle(props) {
  return <Title>{props.children}</Title>;
}

export default AuthTitle;
